/* eslint-disable  max-classes-per-file */
export class AdyenError extends Error {
  constructor(e: unknown) {
    super(`${e}`);
    this.name = 'AdyenError';
    if (e instanceof Error) this.stack = e.stack;
  }
}

export class VelocityCheckError extends Error {
  constructor(e: unknown) {
    super(`${e}`);
    this.name = 'VelocityCheckError';
    if (e instanceof Error) this.stack = e.stack;
  }
}

export class EntitlementsError extends Error {
  constructor(e: unknown) {
    super(`${e}`);
    this.name = 'EntitlementsError';
    if (e instanceof Error) this.stack = e.stack;
  }
}

export class RecaptchaError extends Error {
  constructor(e: unknown) {
    super(`${e}`);
    this.name = 'RecaptchaError';
    if (e instanceof Error) this.stack = e.stack;
  }
}

export class MediaPlayerError extends Error {
  constructor(errorDetails: Error | string) {
    const errorMessage = typeof errorDetails === 'string' ? errorDetails : errorDetails.message;
    super(errorMessage);

    this.name = 'MediaPlayerError';

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, MediaPlayerError);
    }
  }
}

export class TemplateStringError extends Error {
  constructor(e: unknown) {
    super(`${e}`);
    this.name = 'TemplateStringError';
    if (e instanceof Error) this.stack = e.stack;
  }
}
